<script>
import resources from './resources'

export default {
  name: 'professional-addresses-form',
  mixins: [resources]
}
</script>

<template lang="pug">
page(title="Cadastro de endereço", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        medibook-alert-custom(
          :show='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Local de atendimento incluido com sucesso.',
          :buttonsNext='nextStepButtonCompanyAddresses',
          v-if="wasRaised")

        medibook-alert-custom(
          :show='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Local de atendimento incluido com sucesso.',
          :buttonsNext='nextStepButtonIsCompanyAddresses',
          v-if="wasRaised  && userIsCompany")

        medibook-alert-custom(
          :show='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Local de atendimento alterado com sucesso.',
          :buttonsNext='nextStepButtonIsCompanyAddresses',
          v-if="beenUpdated && userIsCompany")

        medibook-alert-custom(
          :show='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Local de atendimento alterado com sucesso.',
          :buttonsNext='nextStepButtonCompanyAddresses',
          v-if="beenUpdated && !userIsCompany")

        .nav-tabs-wrapper
          ul.nav.nav-tabs.nav-340
            li
              router-link(:to="{ name: 'professional.company.addresses.index'}")
                a(href="") Listagem
            li.active
              a Cadastro
        .col-xs-12.white-bg
          .row
            .col-xs-12
              div.col-md-10
                h4 INFORMAÇÕES SOBRE O LOCAL DE ATENDIMENTO
                .form-group
                  .row
                    .col-xs-12.col-sm-8
                      v-input(:status="$v.address.name.$error ? 'error' : null")
                        f-text(label="Nome ou Apelido do Local de Atendimento"
                        v-model="address.name",
                        name="name",
                        :errors="errors['name']")

                    .col-xs-12.col-sm-4
                      v-input(:status="$v.address.zip.$error ? 'error' : null")
                        label CEP
                        f-zip(
                          v-model="address.zip",
                          @on-get-address="setAddress",
                          :errors="errors['zip']")

                .form-group
                  .row
                    .col-xs-12.col-sm-6
                      v-input(:status="$v.address.street.$error ? 'error' : null")
                        f-text(label="Logradouro"
                          v-model="address.street",
                          name="street",
                          :errors="errors['street']")

                    .col-xs-12.col-sm-2
                      v-input(:status="$v.address.number.$error ? 'error' : null")
                        f-text(label="Número"
                          v-model="address.number",
                          name="number",
                          :errors="errors['number']")

                    .col-xs-12.col-sm-4
                      f-text(label="Complemento"
                      v-model="address.complement",
                      name="complement",
                      :errors="errors['complement']")

                .form-group
                  .row
                    .col-xs-12.col-sm-6
                      v-input(:status="$v.address.district.$error ? 'error' : null")
                        f-text(label="Bairro"
                          v-model="address.district",
                          name="district",
                          :errors="errors['district']")

                    .col-xs-12.col-sm-4
                      v-input(:status="$v.address.city.$error ? 'error' : null")
                        f-text(label="Cidade"
                          v-model="address.city",
                          name="city",
                          :errors="errors['city']")

                    .col-xs-12.col-sm-2
                      v-input(:status="$v.address.state.$error ? 'error' : null")
                        f-select-state(label="Estado",
                         name="state",
                         v-model="address.state",
                         :searchable="true",
                         :errors="errors['state']")

                .form-group
                  .row
                    .col-xs-12.col-sm-8(v-if="address.id")
                      v-input(:status="$v.address.email.$error ? 'error' : null")
                        f-text(label="E-mail"
                          name="email",
                          v-model="address.email",
                          :errors="errors['email']")

                    .col-xs-12.col-sm-8(v-if="!userIsCompany && !address.id")
                      v-input(:status="$v.address.email.$error ? 'error' : null")
                        f-text(label="E-mail"
                          name="email",
                          v-model="address.email",
                          :errors="errors['email']")

                    .col-xs-12.col-sm-8(v-if="userIsCompany && !address.id")
                      v-input(:status="$v.address.email.$error ? 'error' : null")
                        f-text(label="E-mail"
                          name="email",
                          v-model="address.email",
                          :errors="errors['email']")

                    .col-xs-12.col-sm-4
                      v-input(:status="$v.address.parking.$error ? 'error' : null")
                        f-select(label="Estacionamento",
                         name="parking",
                         v-model="address.parking",
                         :options="parkingOptions",
                         :searchable="false",
                         :errors="errors['parking']")

                .white-space
                h4 ADICIONE OS TELEFONES DE CONTATO RELACIONADOS AO LOCAL DE ATENDIMENTO
                .add-phones
                  .row
                    .col-xs-12.col-md-3
                      f-select(label="Tipo de Telefone",
                       name="phone_type",
                       v-model="phone.type",
                       :options="phoneTypesOptions",
                       :searchable="false")
                    // @todo Verificar este id duplicado number
                    .col-xs-12.col-md-3
                      label Número
                      f-phone(
                        name="phone_number",
                        v-model="phone.number",
                        placeholder="00 0000-0000")

                    .col-xs-12.col-md-3(v-if="phone.type!=='mobile'")
                      f-text(type="number", :step="1", :min="1", :max="999999", :maxlength="6", label="Ramal", name="phone_exten", v-model="phone.exten")
                    .col-xs-12.col-md-3.pull-right
                      a.btn.find-filled(tabindex='0', @click.prevent="addPhone()")
                        span.icon 
                        |  Adicionar
                  .white-space
                  .row
                    .col-xs-12.numbers-list
                      label Lista de Telefones do Estabelecimento
                      br
                      small.empty(v-if="address.phones.length === 0") Nenhum telefone adicionado
                      .number-list(v-if="address.phones.length > 0", v-for="phone in address.phones")
                        input#phones(type="hidden" name="phones[]" value="(41) 5555-55||Celular")
                        span.icon(v-if="phone.type === 'mobile'") 
                        span.icon(v-if="phone.type !== 'mobile'") 
                        |   {{ phone.number }} {{ phone.exten }}
                        .exclude(@click.prevent="doDeletePhone(phone)") 
                  //--.add-phones

                    //-- Removido devido ao novo modulo
                    //--.row
                      .col-xs-12.col-md-12
                        f-file-text(v-if="!address.attachment.uuid", label="Anexar comprovante de endereço"
                         v-model="address.attachment",
                         name='attachment',
                         :errors="errors['attachment'] || errors['attachment.file'] || errors['attachment.mime']")

                .buttons-wrapper(v-if="(!saved || !address.id)")
                  button.btn.save.pull-right(@click.prevent="doSave()")
                    span.icon 
                    |  Salvar Endereço
                    .border-botton
</template>



// WEBPACK FOOTER //
// src/app/professional/company/addresses/form/form.vue